<template>
  <BaseLayout>
    <template v-if="initComplete">
      <RouterView v-slot="{ Component }">
        <component :is="Component" :key="moduleKey" />
      </RouterView>
    </template>
  </BaseLayout>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";

import BaseLayout from "@/layouts/BaseLayout.vue";
import { useUserSettingsStore } from "@/store/userSettings";

const initComplete = ref(false);
const route = useRoute();

// Optimize: Memoize moduleId to prevent unnecessary component re-renders
const moduleKey = computed(() => route.params.moduleId as string | undefined);

const userSettingsStore = useUserSettingsStore();

onBeforeMount(async () => {
  // Optimize: Avoid redundant refresh if settings already loaded
  if (userSettingsStore.userSettings.length === 0) {
    try {
      await userSettingsStore.refreshSettings();
      userSettingsStore.applyAccentColor();
    } catch (error) {
      console.warn("Failed to load user settings:", error);
    }
  }
  initComplete.value = true;
});
</script>

<style module lang="scss"></style>
